import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { InputAdornment } from '@mui/material';
import { parseFloatWithComma } from 'webui/utils/number';
import { unpack_validation } from 'webui/Z3KConfigParser/validation/types';
import { NullableNumberInput } from 'console/shared/components/fields';
import { SettingCard } from 'console/device-settings/z3k/components/material-utils/settings-card/card';
import { HeatingCircuit } from 'z3k-config';
import { Control } from 'console/shared/components/fields/control';
export const circuit_target_minmax = (type, control_mode, water_min_temperature, water_max_temperature) => {
    if (type === HeatingCircuit.Type.DHW) {
        return [20, 70];
    }
    else if (type === HeatingCircuit.Type.HEATING &&
        control_mode === HeatingCircuit.ControlMode.WATER) {
        return [water_min_temperature ?? 5, water_max_temperature ?? 35];
    }
    else if (type === HeatingCircuit.Type.COOLING) {
        return [0, 80];
    }
    else {
        return [5, 35];
    }
};
const TargetTemperatureSettings = memo(function TargetTemperatureSettings(props) {
    const { state, validation, onChangeTabState } = props;
    const { circuit, control_mode, water_min_temperature, water_max_temperature, target_temperatures, } = state;
    const [temp_min, temp_max] = useMemo(() => circuit_target_minmax(circuit.type, control_mode, parseFloatWithComma(water_min_temperature), parseFloatWithComma(water_max_temperature)), [circuit, control_mode, parseFloatWithComma, circuit_target_minmax]);
    const temperatures = useMemo(() => target_temperatures.map(([mode, target_temp], i) => {
        const onChangeTemperature = (value) => onChangeTabState({
            target_temperatures: target_temperatures.map((item) => {
                const mode2 = item[0];
                if (mode2.id === mode.id)
                    return [mode2, value];
                return item;
            }),
        });
        return (_jsx(Control, { label: mode.name, 
            //@ts-ignore
            validation_result: unpack_validation(validation, 'target_temperatures', i), validation_warnings_result: null, value: target_temp, onChange: onChangeTemperature, field: (input_props) => (_jsx(NullableNumberInput, { ...input_props, min: temp_min, max: temp_max, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u00B0C" }) })) }, mode.id));
    }), [target_temperatures, onChangeTabState, temp_max, temp_min]);
    return (_jsx(SettingCard, { title: "\u0426\u0435\u043B\u0435\u0432\u0430\u044F \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0430 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F", children: temperatures }));
});
export { TargetTemperatureSettings };
